
import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import DatePicker from "react-datepicker";
import API from 'util/API';
import { showErrorSnackbar } from 'store/actions/snackbarMessage';
import { useDispatch } from 'react-redux';

import LinearProgress from "@mui/material/LinearProgress";

import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    table: {


    },
}));



const DishReport = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const showError = (msg) => dispatch(showErrorSnackbar(msg));


    const getDateReportData = async () => {
     
        try {
            setIsLoading(true);
            const startDateStr = formateDate(startDate);
            const endDateStr = formateDate(endDate);
            const rewsponse = await API.get(`/dishReport?startDateStr=${startDateStr}&endDateStr=${endDateStr}`);
            const data = await rewsponse.data;
           // console.log('data', data);
            if (data) {
                setReportData(data);
            } else {
                setReportData([]);
            }


        } catch (err) {
            console.log(err);
            setReportData([]);
        }
    };

    const formateDate = (date) => {
        return moment(date).format('YYYY-MM-DD')
      };

      const queryDate = () => {
        getDateReportData()  
    };
    

    return (
        <div className={classes.root}>
        {isLoading ? <LinearProgress style = {{ marginBottom: 8 }}/> : null}
          
                <Grid
                    item
                    lg={8}
                    md={12}
                    xl={9}
                    xs={12}
                    container direction="row" alignItems="center"
                >
                    <Typography style={{ margin: theme.spacing(1) }}>Start Date</Typography>
                    <DatePicker selected={startDate}  dateFormat="dd/MM/yyyy"
                    onChange={date => setStartDate(date)} />
                    <Typography style={{ margin: theme.spacing(1) }}>End Date</Typography>
                    <DatePicker selected={endDate}  dateFormat="dd/MM/yyyy"
                    onChange={date => setEndDate(date)} />

                    
           <Button
            color="primary"
            variant="contained"
            style={{ marginLeft: theme.spacing(1)}}
            onClick={e => queryDate()}
          >
            Query
        </Button>
                </Grid>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="dish table">
                    {/* {showtotal && showtotal === true ? */}
                        <TableHead>
                            <TableRow>
                                <TableCell  align="right" colSpan={3} component="th" scope="row" >
                                    <Typography>
                                    {formateDate(startDate)} - {formateDate(endDate)}
                                    </Typography>
                                </TableCell>

                            </TableRow>
                        </TableHead>
                        {/* : null} */}
                    <TableHead>
                        <TableRow>
                            <TableCell>No</TableCell>
                            <TableCell align="right">Name</TableCell>
                            <TableCell align="right">Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reportData.length > 0 && reportData.slice(0, 10).map((item, index) => {
                            return (
                                <TableRow key={item.name}>
                                    <TableCell component="th" scope="row" >

                                        {index + 1}

                                    </TableCell>
                                    <TableCell align="right">{item.name}</TableCell>
                                    <TableCell align="right">{item.count}</TableCell>

                                </TableRow>
                            )
                        })}


                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}

export default DishReport;
